import React from 'react';
import { Box } from '@mui/material';

const Thumbnail = ({
  src,
  alt = "Thumbnail",
  width = 120,
  height = 120,
  borderRadius = 1,
  onClick,
  sx = {}
}) => {
  return (
    <Box
      component="img"
      src={src}
      alt={alt}
      onClick={onClick}
      sx={{
        width,
        height,
        borderRadius,
        objectFit: 'cover',
        cursor: onClick ? 'pointer' : 'default',
        transition: 'all 0.2s ease',
        '&:hover': onClick ? {
          transform: 'scale(1.05)',
          boxShadow: 2
        } : {},
        ...sx
      }}
    />
  );
};

export default Thumbnail;
